import apiClient from '../client.js'

export const shippingAPI = {
  // Public shipping endpoints
  async getShippingMethods() {
    const response = await apiClient.get('/shipping/methods')
    return response.data
  },

  async calculateShipping(shippingData) {
    const response = await apiClient.post('/shipping/calculate', shippingData)
    return response.data
  },

  // Admin shipping endpoints
  async getAdminShippingMethods(params = {}) {
    const response = await apiClient.get('/admin/shipping/methods', { params })
    return response.data
  },

  async getShippingStats() {
    const response = await apiClient.get('/admin/shipping/stats')
    return response.data
  },

  async createShippingMethod(shippingData) {
    const response = await apiClient.post('/admin/shipping/methods', shippingData)
    return response.data
  },

  async getShippingMethod(shippingMethodId) {
    const response = await apiClient.get(`/admin/shipping/methods/${shippingMethodId}`)
    return response.data
  },

  async updateShippingMethod(shippingMethodId, shippingData) {
    const response = await apiClient.put(`/admin/shipping/methods/${shippingMethodId}`, shippingData)
    return response.data
  },

  async deleteShippingMethod(shippingMethodId) {
    const response = await apiClient.delete(`/admin/shipping/methods/${shippingMethodId}`)
    return response.data
  },

  async toggleShippingMethodActive(shippingMethodId) {
    const response = await apiClient.patch(`/admin/shipping/methods/${shippingMethodId}/toggle-active`)
    return response.data
  }
}
